import gql from "graphql-tag";

export const UploadMutation = gql`
    mutation uploadImage($file: Upload!, $restaurantCode: String!) {
        uploadImage(file: $file, restaurantCode: $restaurantCode)
    }
`;
